import { render } from "./AppSignOut.vue?vue&type=template&id=32d7b1cd&lang=pug"
import script from "./AppSignOut.vue?vue&type=script&lang=ts"
export * from "./AppSignOut.vue?vue&type=script&lang=ts"
script.render = render

export default script